<template>
  <div id="app">
    <div class="sticky-nav px-4">
      <div
        class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
      >
        <h1 class="h2">Klanten</h1>
      </div>

      <div class="dropdown">
        <button
          class="btn btn-dark"
          type="button"
          id="dropdownMenuButton"
          v-on:click="modalToevoegenKlant()"
        >
          <i class="fas fa-plus"></i> Klant toevoegen
        </button>

        <button
          class="btn btn-dark ml-1"
          type="button"
          id="dropdownMenuButton"
          v-on:click="modalExporteren()"
        >
          <i class="fas fa-plus"></i> Exporteren
        </button>
      </div>
    </div>

    <br />
    <br />

    <vue-good-table
      v-if="klanten && klanten.length"
      class="mb-3 px-4"
      @on-selected-rows-change="selectionChanged"
      @on-cell-click="onRowClick"
      :columns="klantColumns"
      :rows="klanten"
      :pagination-options="{
        enabled: true,
        mode: 'pages',
        perPage: 100,
        position: 'bottom',
        perPageDropdown: [25, 50, 100],
        setCurrentPage: 1,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'Rows per page',
        ofLabel: 'of',
        pageLabel: 'page', // for 'pages' mode
        allLabel: 'All',
        dropdownAllowAll: true,
      }"
      :selectOptions="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
      }"
    />

    <!-- Modal -->
    <div
      class="modal fade"
      id="klantModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ editModalTitle }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="klant">
              <label>Type</label>
              <select class="form-control" v-model="klant.type">
                <option value="Zakelijk">Zakelijk</option>
                <option value="Particulier">Particulier</option>
              </select>
              <label>Betalingstermijn</label>
              <select
                v-model="klant.betalingstermijn"
                class="form-control"
                v-if="klant.type == 'Particulier'"
              >
                <option value="Contant">Contant</option>
              </select>
              <select
                v-model="klant.betalingstermijn"
                class="form-control"
                v-else
              >
                <option value="Contant">Contant</option>
                <option value="7 dagen">7 dagen</option>
                <option value="15 dagen">15 dagen</option>
                <option value="30 dagen">30 dagen</option>
              </select>
              <label>Bedrijf</label>
              <input
                type="text"
                class="form-control"
                v-model="klant.bedrijfsnaam"
                placeholder="Bedrijf"
              />
              <label>BTW</label>
              <input
                type="text"
                class="form-control"
                v-model="klant.btw"
                placeholder="BTW"
              />
              <label>Naam</label>
              <input
                type="text"
                class="form-control"
                v-model="klant.naam"
                placeholder="Naam"
              />
              <label>Voornaam</label>
              <input
                type="text"
                class="form-control"
                v-model="klant.voornaam"
                placeholder="Voornaam"
              />
              <label>Straat</label>
              <input
                type="text"
                class="form-control"
                v-model="klant.straat"
                placeholder="Straat"
              />
              <label>Huisnummer</label>
              <input
                type="text"
                class="form-control"
                v-model="klant.huisnummer"
                placeholder="Huisnummer"
              />
              <label>Postcode</label>
              <input
                type="text"
                class="form-control"
                v-model="klant.postcode"
                placeholder="Postcode"
              />
              <label>Gemeente</label>
              <input
                type="text"
                class="form-control"
                v-model="klant.gemeente"
                placeholder="Gemeente"
              />
              <label>Land</label>
              <input
                type="text"
                class="form-control"
                v-model="klant.land"
                placeholder="Land"
              />
              <label>E-mail</label>
              <input
                type="text"
                class="form-control"
                v-model="klant.email"
                placeholder="E-mail"
              />
              <label>Telefoon</label>
              <input
                type="text"
                class="form-control"
                v-model="klant.telefoon"
                placeholder="Telefoon"
              />
              <label>Website</label>
              <input
                type="text"
                class="form-control"
                v-model="klant.website"
                placeholder="Website"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              v-if="checkNewKlant === false"
              type="button"
              class="btn btn-danger"
              v-on:click="deleteKlant()"
            >
              Verwijderen
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Sluiten
            </button>
            <button
              v-if="checkNewKlant"
              type="button"
              class="btn btn-primary"
              v-on:click="createKlant()"
            >
              Opslaan
            </button>
            <button
              v-else
              type="button"
              class="btn btn-primary"
              v-on:click="updateKlant()"
            >
              Aanpassen
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="exportModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Exporteren
            </h5>
          </div>
          <div class="modal-body">
            <label>Klant</label>
            <model-list-select
              :list="klantenLijst"
              option-value="id"
              option-text="klantnaam"
              v-model="exportSettings.klant"
              placeholder="- Kies klant -"
            ></model-list-select>
            <label>Datum van</label>
            <date-picker
              v-model="exportSettings.datum_van"
              placeholder="Kies datum"
              :value-type="'YYYY-MM-DD'"
              :editable="false"
              :format="'YYYY-MM-DD'"
            ></date-picker>
            <label>Datum tot</label>
            <date-picker
              v-model="exportSettings.datum_tot"
              placeholder="Kies datum"
              :value-type="'YYYY-MM-DD'"
              :editable="false"
              :format="'YYYY-MM-DD'"
            ></date-picker>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              v-on:click="returnModal()"
            >
              Terug
            </button>
            <button
              type="button"
              class="btn btn-primary"
              v-on:click="printExport()"
            >
              Exporteren
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "bootstrap";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/nl-be";

export default {
  name: "app",
  components: {
    ModelListSelect,
    DatePicker,
  },
  data() {
    return {
      exportSettings: {},
      checkNewKlant: false,
      importType: "-1",
      importCategory: "-1",
      types: [
        {
          name: "Klanten",
        },
        {
          name: "Contacten",
        },
        {
          name: "Leveradressen",
        },
      ],
      editModalTitle: "",
      klant: {},
      klantenLijst: [],
      klanten: {
        attributes: [],
        related: [],
      },
      klantColumns: [
        {
          label: "Bedrijf",
          field: "bedrijfsnaam",
          filterOptions: { enabled: true },
        },
        {
          label: "Naam",
          field: "naam",
          filterOptions: { enabled: true },
        },
        {
          label: "Voornaam",
          field: "voornaam",
          filterOptions: { enabled: true },
        },
        {
          label: "Adres",
          field: this.adresFn,
          filterOptions: { enabled: true },
        },
        {
          label: "Postcode",
          field: "postcode",
          filterOptions: { enabled: true },
        },
        {
          label: "Gemeente",
          field: "gemeente",
          filterOptions: { enabled: true },
        },
        { label: "Land", field: "land", filterOptions: { enabled: true } },
        { label: "BTW", field: "btw", filterOptions: { enabled: true } },
        { label: "Email", field: "email", filterOptions: { enabled: true } },
      ],
      attrPos: 0,
    };
  },
  mounted() {
    this.getKlanten();
  },
  methods: {
    printExport() {
      window.open(
        "https://hofman.weblion.be/api/export.php?k=" +
          this.exportSettings.klant +
          "&dv=" +
          this.exportSettings.datum_van +
          "&dt=" +
          this.exportSettings.datum_tot,
        "_blank"
      );
    },
    adresFn(rowObj) {
      return rowObj.straat + " " + rowObj.huisnummer;
    },
    getKlanten() {
      axios.get("https://hofman.weblion.be/api/klanten/").then((response) => {
        this.klanten = response.data;
        this.klantenLijst = response.data;
        console.log(this.klanten);
      });
    },
    deleteKlant() {
      axios
        .delete("https://hofman.weblion.be/api/klanten/", {
          data: {
            klant_id: this.klant.id,
          },
        })
        .then((response) => {
          this.getKlanten();
          $("#klantModal").modal("hide");
          console.log(response.data);
        });
    },
    updateKlant() {
      axios
        .put("https://hofman.weblion.be/api/klanten/", {
          klant: this.klant,
        })
        .then((response) => {
          this.getKlanten();
          $("#klantModal").modal("hide");
          console.log(response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    createKlant() {
      axios
        .post("https://hofman.weblion.be/api/klanten/", {
          klant: this.klant,
        })
        .then((response) => {
          this.getKlanten();
          $("#klantModal").modal("hide");
          console.log(response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    modalToevoegenKlant() {
      this.klant = {};
      this.klant.type = "Zakelijk";
      this.editModalTitle = "Klant toevoegen";

      this.checkNewKlant = true;

      $("#klantModal").modal("show");
    },
    modalExporteren() {
      $("#exportModal").modal("show");
    },
    onRowClick(table) {
      this.editModalTitle = "Klant aanpassen";
      this.klant = table.row;

      this.checkNewKlant = false;

      $("#klantModal").modal("show");
    },
    selectionChanged(table) {
      this.klantenSelected = table.selectedRows;
    },
    modalAanpassenKlant() {
      this.checkNewKlant = false;
      this.editModalTitle = "Klant aanpassen";

      $("#klantModal").modal("show");
    },
    sKlant() {
      axios
        .post("https://hofman.weblion.be/api/klanten/update.php", {
          klant: this.klant,
        })
        .then((res) => {
          console.log(res);
          this.getKlanten();
        })
        .then(function() {
          $("#klantModal").modal("hide");
        });
    },
  },
};
</script>

<style>
button {
  margin-right: 10px;
}
.table thead th {
  text-align: left !important;
}
.pager ul {
  list-style-type: none;
}
.pager ul li {
  display: inline-block;
  border: 1px solid #dee2e6;
  border-radius: 3px;
  padding: 5px;
  width: 40px;
  text-align: center;
  margin: 2px;
}
.modal input,
.modal select {
  margin-bottom: 5px;
}
.modal-body label {
  display: inline-block;
  width: 32%;
}

.modal-body .form-control {
  display: inline-block;
  width: 68%;
}

.modal-body select {
  text-indent: 5px;
}

#exampleModal input {
  display: block;
  width: 100%;
}

#importModal .modal-body label {
  width: auto;
}

#importModal input,
#importModal select {
  display: inline-block;
  width: 49%;
  margin-bottom: 5px;
}

#importModal .match-wrapper,
#importModal form {
  width: 100%;
}
#importModal select {
  margin-left: 1%;
}

#importModal .fullw {
  display: block;
  width: 100%;
  border-radius: 4px;
}

#importModal .fullw select {
  margin: 0;
}

#importModal .fullw input {
  display: block;
  width: 100%;
  margin: 0;
}

.dropdown {
  display: inline-block;
}
.dropdown-item:hover {
  cursor: pointer !important;
}
.dropdown-item i {
  margin-right: 3px;
}
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 550px;
    margin: 1.75rem auto;
  }
}
.groupedState {
  display: inline-block;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  margin-left: 25%;
}

#autoGroupModal table tr td {
  padding: 2px 10px;
}

#autoGroupModal .modal-title span {
  color: #777;
  font-size: 14px;
  margin-left: 10px;
}

#autoGroupModal input {
  width: 100%;
}

#autoGroupModal .form-check-input {
  width: auto;
  position: relative;
  margin: 0;
  vertical-align: 2px;
}

.ck.ck-editor {
  display: inline-block !important;
  width: 68% !important;
  margin-bottom: 5px !important;
}

.sticky-nav {
  position: fixed;
  height: 150px;
  top: 50;
  z-index: 2;
  background: white;
  padding-top: 10px;
  width: 100%;
  margin-top: -10px;
}

#klantModal textarea {
  height: 100px;
}

.vgt-wrap {
  margin-top: 120px;
}

label {
  vertical-align: top;
}

[data-g="1"] {
  background: #8cc040;
}

[data-g="0"] {
  background: red;
}
.btn-danger {
  margin-right: 210px;
}
</style>
